import baseAPI from '@/http'

const router = 'api/acompanhamento/acompanhamentoPercentualTema'

export const attendanceThemeAPI = {
  list: () => baseAPI.get(router),
  getByCity: (id) => baseAPI.get(`${router}/get-by-municipio/${id}`)
}
